import React, { useMemo, useState } from "react";
import {
  View,
  Dimensions,
  SectionList,
  StyleSheet,
  Modal,
  Image,
  TouchableOpacity,
} from "react-native";
import Text from "@components/CustomText";
import HTML from "react-native-render-html";
import { format } from "date-fns";

const Conversation = ({ ticketDetails }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [imageDimensions, setImageDimensions] = useState({});
  const today = format(new Date(), "do MMM yyyy");
  const { conversations = {}, attachments = [] } = ticketDetails;
  const screenWidth = Dimensions.get("window").width;
  const orderedConversations = useMemo(() => {
    if (ticketDetails.description_new) {
      conversations.push({
        created_at: ticketDetails.created_at,
        body: ticketDetails.description_new,
        incoming: true,
        id: 1,
      });
    }
    conversations.reverse();
    return conversations.reduce((acc, cur) => {
      let date = format(new Date(cur.created_at), "do MMM yyyy");
      let time = format(new Date(cur.created_at), "hh:mm aaaa");
      let existing = acc.find(
        (el) => el.date.toString().trim() === date.toString().trim(),
      );
      if (
        cur.from_email ===
        '"Citymall Support" <support@citymallassist.freshdesk.com>'
      ) {
        cur.incoming = true;
      }
      if (!existing) {
        existing = {
          date,
          data: [],
        };
        existing.data.push({ ...cur, time });
        acc.push(existing);
      } else if (existing) {
        existing.data.push({ ...cur, time });
      }

      return acc;
    }, []);
  }, [ticketDetails, conversations]);

  const handleImageClick = (uri) => {
    setModalImage(uri);
    setModalVisible(true);
  };

  const fetchImageDimensions = (uri) => {
    if (!imageDimensions[uri]) {
      Image.getSize(
        uri,
        (width, height) => {
          const aspectRatio = width / height;
          setImageDimensions((prevState) => ({
            ...prevState,
            [uri]: {
              width: screenWidth / 2,
              height: screenWidth / 2 / aspectRatio,
            },
          }));
        },
        (error) => {
          console.error(`Failed to get image size: ${error.message}`);
        },
      );
    }
  };

  const renderers = {
    img: ({ TDefaultRenderer, ...props }) => {
      fetchImageDimensions(props.src);
      const dimensions = imageDimensions[props.src] || {
        width: screenWidth / 2,
        height: 100,
      };
      return (
        <TouchableOpacity onPress={() => handleImageClick(props.src)}>
          <Image
            src={props.src}
            style={{ width: dimensions.width, height: dimensions.height }}
            resizeMode="contain"
          />
        </TouchableOpacity>
      );
    },
  };

  return (
    <View style={{ backgroundColor: "white", padding: 15, flex: 1 }}>
      <SectionList
        sections={orderedConversations}
        keyExtractor={(item, index) => `${item}${index}`}
        initialNumToRender={100}
        renderSectionHeader={({ section: { date } }) => (
          <View
            style={{
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              paddingVertical: 8,
            }}
          >
            <Text
              style={{
                fontFamily: "NotoSansDevanagari-Regular",
                fontSize: 12,
                lineHeight: 18,
                color: "rgba(0,0,0,0.56)",
              }}
            >
              {today.toString().trim() === date.toString().trim()
                ? "आज "
                : date}
            </Text>
          </View>
        )}
        renderItem={({ item }) => {
          return (
            <View
              style={{
                paddingHorizontal: 15,
              }}
            >
              <View
                style={[
                  {
                    borderRadius: 10,
                    width: "80%",
                    marginBottom: 10,
                  },
                  item.incoming ? styles.sentStyle : styles.receivedStyle,
                ]}
              >
                <View style={{ padding: 15, paddingBottom: 0 }}>
                  <HTML
                    ignoredTags={["br", "a"]}
                    html={item?.body_new ? item.body_new : item?.body}
                    contentWidth={"100%"}
                    renderers={renderers}
                  />
                </View>
                <View style={{ padding: 10, paddingTop: 3 }}>
                  <Text
                    style={{
                      marginLeft: "auto",
                      fontFamily: "NotoSansDevanagari-Regular",
                      fontSize: 12,
                      lineHeight: 16,
                      color: "rgba(0,0,0,0.56)",
                    }}
                  >
                    {item.time}
                  </Text>
                </View>
              </View>
            </View>
          );
        }}
      />
      <Modal
        statusBarTranslucent
        navigationBarTranslucent
        visible={modalVisible}
        onRequestClose={() => setModalVisible(false)}
        transparent={true}
      >
        <TouchableOpacity onPress={() => setModalVisible(false)}>
          <View style={styles.modalContent}>
            <Image
              source={{ uri: modalImage }}
              style={styles.modalImage}
              resizeMode="contain"
            />
          </View>
        </TouchableOpacity>
      </Modal>
    </View>
  );
};

export default Conversation;

const styles = StyleSheet.create({
  sentStyle: {
    backgroundColor: "#FDF7EB",
    marginLeft: "auto",
  },
  receivedStyle: {
    backgroundColor: "#F2F2F2",
    marginRight: "auto",
  },
  modalContent: {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    padding: 20,
    justifyContent: "center",
    alignItems: "center",
  },
  modalImage: {
    width: "100%",
    height: "100%",
  },
});
